<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <iframe
      src="https://player.vimeo.com/video/412475752"
      width="640"
      height="175"
      frameborder="0"
      allow="autoplay; fullscreen"
      allowfullscreen
    ></iframe>
    <FCCopy :h2="this.h2" :h3="this.h3">
      <template v-slot:copy>
        <iframe
          src="https://player.vimeo.com/video/412475752"
          width="640"
          height="175"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
        <p>Fans young and old, from different races, religions, neighborhoods, backgrounds, nationalities and all walks of life come together each game to take part in the ritual of The March. Renowned around the league, The March through the city and into the stadium ignites the entire fanbase before the game, and the drumming and singing doesn’t stop until the final whistle.</p>
      </template>
    </FCCopy>
  </div>
</template>

<script>
import FCCopy from "@/components/patterns/FCCopy";
export default {
  components: {
    FCCopy
  },
  mounted() {
    const ref = this.$store.state.menu.ourFans.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.ourFans.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.ourFans.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Our Fans",
      h3: "This is Cincy"
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-cincy.jpg");
  background-size: cover;
  background-position: center;

  > iframe {
    width: 50%;
    height: 275px;
    position: absolute;
    top: 250px;
    left: 150px;
    z-index: 1;
    max-width: calc(100% - 686px - 150px - 50px);
  }
}

@media (max-width: 1000px) {
  .page__wrapper > iframe {
    display: none;
  }
  .page__wrapper {
    padding-top: 50vh;
  }
}
</style>